import React from 'react';
import { mixClasses } from '../../helpers/utilities';
import { CartItemsHeader } from './CartItemsHeader';
import { CartItem } from './CartItem';

export const CartItemsList = ({ items, className, onItemChange, onItemRemove, footer = null }) => {
    return (
        <ul className={mixClasses(['list-group', className])}>
            <CartItemsHeader />
            {items.map((item) => (
                <CartItem
                    key={item.id}
                    item={item}
                    onChange={onItemChange}
                    onRemove={onItemRemove}
                />
            ))}
            {footer && footer()}
        </ul>
    );
};
